<template>

    <header class="sticky-top">
        <b-navbar toggleable="lg" type="dark" class="header-nav py-0" :class="admin_mode!='project'?'bgray-800 ':'bg-tealgray900'">
            <b-navbar-brand>
                <div class="cursor pl-0 pl-sm-2" @click="pageGo('',{name:'Main'})">
                    <b-img class="header-logo" src="/images/QESG_Assessment_mixed.svg"></b-img>
                </div>
            </b-navbar-brand>

            <b-navbar-toggle target="user-header-collapse" class="ml-auto py-3"></b-navbar-toggle>
            
            <b-collapse id="user-header-collapse" is-nav>
                <b-navbar-nav class="mx-auto d-lg-flex align-items-lg-center"  @mouseleave="show_sub_menu=false">
                    <b-nav-item
                        :class="[admin_mode=='project' ? 'active-head':'', 'mx-3 py-3']"
                        @click.stop="pageGo('project', {name: 'ProjectCodeList'})"
                        @mouseover="show_sub_menu=false"
                        >
                        프로젝트 뷰어
                    </b-nav-item>
                    <b-nav-item v-if="is_admin === 4"
                        :class="[admin_mode=='camp' ? 'active-head':'', 'mx-3 py-3']"
                        @mouseover="show_sub_menu = false"
                        @click.stop="pageGo('camp', {name: 'CampaignList'})"
                        >
                        캠페인 관리
                    </b-nav-item>
                    <b-nav-item v-if="is_admin === 4"
                        :class="[admin_mode=='template' ? 'active-head':'', 'mx-3 py-3']"
                        @mouseover="show_sub_menu = false"
                        @click.stop="pageGo('template', {name: 'TemplateList'})"
                        >
                        질문지 관리
                    </b-nav-item>
                    <!-- <b-nav-item v-if="is_admin >= 3"
                        :class="[{'active-head': admin_mode === 'user'}, 'mx-3 py-3 position-relative']"
                        @click="pageGo('user',{name: 'ManagingCompany'})"
                        @mouseover="showSubMenu('participants')"
                        >
                        참여대상 관리
                        <div @mouseover="showSubMenu('participants')" :class="show_sub_menu==true&&is_participants_sub==true?'position-absolute sub-menu-box':'d-none'" style="width: 200px;">
                            <b-button-group vertical>
                                <b-button @click="pageGo('user',{name: 'ManagingCompany'})" class="f-90 text-left py-2 px-3 no-shadow" variant="dark">기업 & 참여자 관리</b-button>
                                <b-button @click="pageGo('user',{name: 'ManagingUser', params: { target_company_name: '' }})" class="f-90 text-left py-2 px-3" variant="dark">참여자 등록</b-button>
                                <b-button @click="pageGo('user',{name: 'PortfolioList'})" class="f-90 text-left py-2 px-3 no-shadow" variant="dark" v-if="is_admin==4">기업 리스트 관리</b-button>
                            </b-button-group>
                        </div>
                    </b-nav-item> -->
                    <!-- <b-nav-item @mouseover="showSubMenu('')" :class="[admin_mode=='operation' ? 'active-head':'', 'mx-3 py-3 position-relative']" v-if="is_admin >=3"> 운영 관리
                        <div @mouseover="showSubMenu('')" :class="show_sub_menu==true&&is_participants_sub!=true? 'position-absolute sub-menu-box':'d-none'" style="width: 200px;">
                            <b-button-group vertical>
                                <b-button @click="pageGo('operation', {name: 'NoticeManager'})" class="f-90 text-left py-2 px-3 no-shadow" variant="dark">공지하기</b-button>
                                <b-button @click="pageGo('operation', {name: 'CsManager'})" class="f-90 text-left py-2 px-3 no-shadow" variant="dark">문의사항 관리</b-button>
                            </b-button-group>
                        </div>
                    </b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>

            <b-button
                v-if="is_admin === 4"
                :to="{ name: 'ManagingAssessment' }"
                link-classes="h5 mb-0"
                class="btn-round-4 mr-2"
                size="sm"
                variant="primary"
                >
                📣 운영관리
            </b-button>

            <b-button
                v-if="show_ai_manage"
                :to="{ name: 'ManagingAiAssessment' }"
                link-classes="h5 mb-0"
                class="btn-round-4 mr-2"
                size="sm"
                variant="primary"
            >
                🤖 AI 평가 관리
            </b-button>


            <DropdownLanguage size="sm" dropdown-variant="danger" />
            <b-button
                id="my-info"    
                class="btn-round-2 ml-2 ml-lg-2"
                size="sm"
                variant="dark"
                @click.stop="showMyInfo"
                >
                <fa :icon="['far','user']"></fa>
            </b-button>
            <b-button
                class="btn-round-4 ml-2 ml-lg-2"    
                size="sm"
                variant="dark"
                @click="logout"
                >
                로그아웃
            </b-button>
        </b-navbar>

        <!-- 툴팁 -->
        <b-tooltip target="my-info" triggers="hover"> 내 정보 관리</b-tooltip>
        <!-- <b-tooltip target="to-user-main" triggers="hover"> 캠페인 페이지로 이동 </b-tooltip> -->
        
        <!-- 모달 -->
        <b-modal ref="my-info" size="lg" title="내 정보 관리" hide-footer>
            <user-info></user-info>
        </b-modal>    
    </header>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import UserInfo from '@shared_components/utils/UserInfo';
import DropdownLanguage from '@shared_components/utils/dropdown-language';

export default {
    components: {
        UserInfo,
        DropdownLanguage
    },
    data () {
        return {
            show_sub_menu: false,
            is_participants_sub: false,
        };
    },
    computed: {
        ...mapState(['admin_mode']),
        user_name() {
            return this.$store.getters.getUserName;
        },
        company_name() {
            return this.$store.getters.getCompanyName;
        },
        e_mail(){
            return this.$store.getters.getEMail;
        },
        isAuthenticated(){
            return this.$store.getters.isAuthenticated;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        is_admin(){
            return Number(this.$store.getters.isAdmin);
        },
        show_ai_manage(){
            // hmc 한정 조건은 머지 잔재 — sidebar 는 원래 is_admin 만 보므로 정합 맞춤 (2026-09-01 의도 규명)
            return this.is_admin === 3;
        }
    },
    created () {
        this.$store.commit('set_view_mode', 'user');
    },
    methods: {
        ...mapMutations(['set_admin_mode']),
        ...mapMutations('score', ['add_all_temp_target_companies']),
        showSubMenu(menu){
            this.show_sub_menu = true;
            if (menu=='participants'){                
                this.is_participants_sub = true;
            }
            else this.is_participants_sub = false;
        },
        logout(){
            this.$store.dispatch('logout')
                .then(() => { this.$router.push({name:'Login'});  } );
        },
        showMyInfo() {
            this.$refs['my-info'].show();
        },
        pageGo(mode, destination){
            this.set_admin_mode(mode);
            if(mode=='project') this.add_all_temp_target_companies([]);
            if(mode=='camp') this.add_all_temp_target_companies([]);
            this.$store.commit('update_now_page', destination[name]);
            this.$router.push(destination);
        },
    }
    // watch:{
    //     $route(newV){
    //         if(newV.name=='CampaignList'){

    //         }
    //     }
    // }

};
</script>
<style>

.active-head{
    position: relative;
}
.active-head > .nav-link {
    color: var(--gray-200)!important;
}
.active-head::after {
    position: absolute;
    bottom: 0;
    height: 0;
    width: 0;
    left: calc(50% - 4px);
    border: 8px solid transparent;
    border-bottom-color: var(--gray-200);
    content: "";
}

.sub-menu-box{
    margin-top:4px; 
    left:0;
    z-index: 30;
}

@media (max-width: 992px) {
    .active-head::after {
        position: absolute;
        bottom: 0;
        height: 0;
        width: 0;
        left: calc(50% - 4px);
        border: 0;
        content: "";
    }
    .sub-menu-box{
        margin-top:-25px; 
        left:100px;
        z-index: 30;
    }
}
</style>
